export default __webpack_public_path__ + "static/media/profile.c72fa650.jpg";